<template>
 <div class="app">
    <div class="bar">
        <div class="inputWrap">
            <div style="height:30px;margin-top: 10px;line-height: 30px;">
                <div style="display:flex">
                    <el-radio-group v-model="radio" @change="switchChange()" style="margin-top:10px;height:40px;line-height:40px">
                      <el-radio  label="1">按关键字搜索</el-radio>
                      <el-radio  label="2">按坐标搜索</el-radio>
                    </el-radio-group>
                    <p style="margin:10px 0px 0px 20px;color:#f00" v-if="toastContent">{{toastMsg}}</p>
                </div>
                
                <div>
                  <el-input v-model="inputContent" :placeholder="placeholder" style="width:240px" size="medium"  ></el-input>
                  <el-button type="primary" @click="search()" size="medium" style="margin-left:20px;width:100px">搜索</el-button>
                  <!-- <div v-if="list.length > 0" style="position:absolute;top:90px;width:240px;height:150px;background:#fff;z-index: 2;border:1px solid #44cccc;overflow: auto;">
                      <ul class="list">
                          <li class="poi-item" v-for="(item, idx) in list" :key="item.pid" @click="selectPOI(idx)">{{item.nm}}</li>
                      </ul>
                  </div> -->
                </div>
            </div>
        </div>
        <div class="inputWrap">
            <div style="height:50px;margin-top: 10px;line-height: 50px;color:#666">
              坐标获取结果:
              <span style="margin-left:10px;color:#f00" v-if="toastResult">复制成功</span>
            </div>
            <div>
              <el-input v-model="inputResult" id="inputResult" style="width:240px" :readonly="true" size="medium"></el-input>
              <el-button type="primary" size="medium" @click="copylnglat()" style="margin-left:20px;width:100px">复制</el-button>
            </div>
        </div>
        
    </div>
    <div class="mapWrap" >
      <div  ref="map" style="width:100%;height:100%"></div>
    </div>
    <div id="option-panel" style="z-index:1111">
      <div class="city-selector" v-click-out="closeCityPanel">
            <a class="city-name" @click="toggleCityPanel">{{currentCity}}<span style="padding-left:2px;color: #409eff;">[更换城市]</span></a>
            <div class="city-panel-box">
                <citypanel v-show="showCityPanel" @selected="changeCity"></citypanel>
            </div>
        </div>
    </div>
 </div>
</template>
<script>
import utils from "./assets/js/utils.js";
import citypanel from "./components/citypanel.vue";
import clickOut from './components/outside.js';
import axios from 'axios';

let globalMap;
let markerLnglat;
let markerPoi;


function judgeIE(){
    var ua = navigator.userAgent.toLocaleLowerCase();
    if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
        return true;
    }
    return false;
}

export default {
  directives: { clickOut },
  data(){
    return {
        radio: '1',
        inputContent:'',
        toastResult:false,
        toastContent:false,
        inputResult:'',
        toastMsg:"",
        list:[],
        placeholder:'请输入关键字',
        currentCity: '北京市',
        showCityPanel:false,
        styleHeight:{height:'500px'}
    } 
  },
  components:{citypanel},
  mounted() {
    let lbsnum = utils.ac(8);
    let lbstm = parseInt(new Date().getTime()/1000);
    let str = 'lbsdevchecknum' + window.navigator.userAgent + lbstm;
    let md5str = utils.hex_md5(str);
    let sendUrl = '&lbssign='+md5str +'&lbsnum='+ lbsnum+'&lbstm='+lbstm;
    nimap.accessToken="您的AK"
    globalMap = new nimap.Map({
        container: this.$refs.map,
        style: 'https://lbs.navinfo.com/develop-map-ak/style/normal?' + sendUrl,
        zoom:11, //初始化地图层级
        center: [116.397428, 39.90923], //初始化地图中心点
        localIdeographFontFamily: "PingFang SC,Microsoft YaHei,微软雅黑,Arial,sans-serif,黑体" //字体本地读取
    });

     globalMap.on('moveend', ()=>{
        let zoom  = globalMap.getZoom();
        let center = globalMap.getCenter();
        center =  `${center.lng},${center.lat}`;
        let lbsnum = utils.ac(8);
        let lbstm = parseInt(new Date().getTime()/1000);
        let str = 'lbsdevchecknum' + window.navigator.userAgent + lbstm;
        let md5str = utils.hex_md5(str);
        let sendUrl = '&lbssign='+md5str +'&lbsnum='+ lbsnum+'&lbstm='+lbstm;
        //&ak=Ian3b11M3799Y53179q9zP39vn7l797j
        axios.get(`https://lbs.navinfo.com/develop-api/geocoder/v1/regeo?lonlats=${center}` + sendUrl).then(res=>{
            if(res.status == 200 && res.data.status == 200){
                let ad = res.data.data[0]['ad'] || '';
                if(ad != ''){
                    if(zoom >=11){
                        this.currentCity = ad.city
                    }else if(zoom >= 9){
                        if(ad.prov == '直辖市'){
                            this.currentCity = ad.city
                        }else{
                            this.currentCity = ad.prov
                        }
                    }else{
                        this.currentCity = "全国"
                    }
                }
            }
        })
    });

    globalMap.on('load',()=>{
        let div = document.createElement('div');
        div.className = 'markerLnglat';
        let offset = [90,0];
        if(judgeIE()){
          offset = [0,0];
        }
        markerLnglat = new nimap.Marker({element:div,offset:offset});

        let span = document.createElement('span');
        span.className = 'nimap-marker mark-onway'
        markerPoi = new nimap.Marker({element:span,offset:[0, -12]});

        globalMap.on('mousemove',function(e){
            let lng = e.lngLat.lng.toFixed(6);
            let lat = e.lngLat.lat.toFixed(6);
            if(judgeIE()){
              markerLnglat.options.element.innerHTML = ""+lng+","+lat;
            }else{
              markerLnglat._element.innerHTML=""+lng+","+lat;
            }
            
            
            markerLnglat.setLngLat([e.lngLat.lng,e.lngLat.lat]);
            markerLnglat.addTo(globalMap);
        })

        globalMap.on('mouseout',()=>{
            markerLnglat.remove();
        })

        globalMap.on('click',(e)=>{
            let lng = e.lngLat.lng.toFixed(6);
            let lat = e.lngLat.lat.toFixed(6);
            this.inputResult = ""+lng+","+lat;
        })
    })

    
  },
  methods:{
      toggleCityPanel () {
          this.showCityPanel = !this.showCityPanel;
      },
      changeCity (city) {
          this.showCityPanel = false;
          if(city.city.indexOf('州') != -1 || city.city.indexOf('区') != -1 || city.city.indexOf('盟') != -1 || city.city.indexOf('台湾') != -1 || city.city.indexOf('香港') != -1|| city.city.indexOf('澳门') != -1  ){
            this.currentCity = city.city;
          }else{
            this.currentCity = city.city+'市';
          }
          
          let lnglat = city.lonlat.split(',').map(v=>{return parseFloat(v)});
          globalMap.flyTo({center: lnglat})
      },
      closeCityPanel () {
          this.showCityPanel = false;
      },
      copylnglat(){
        this.toastResult = false;
        if(this.inputResult == ''){
          return ;
        }
        document.getElementById('inputResult').select()
        if (document.execCommand('copy')) {
            document.execCommand('copy');
            this.toastResult = true;
            setTimeout(()=>{
              this.toastResult = false;
            },3000)
        }
      },
      switchChange(){
        this.inputContent = ''
        if(this.radio == '1'){
          this.placeholder = "请输入关键字"
        }else{
          this.placeholder = "请输入坐标经纬度"
        }
      },
      toastMsgFunc(val){
        this.toastMsg = val;
        this.toastContent = true;
        setTimeout(()=>{
          this.toastContent = false;
        },100000)
      },
      // selectPOI(idx){
      //   let poi = this.list[idx];
      //   this.inputContent = poi.nm || '未知';
      //   this.inputResult = poi.lonlat
      //   let lnglat = poi.lonlat.split(',').map(v=>{return parseFloat(v)});
      //   markerPoi.setLngLat(lnglat);
      //   markerPoi.addTo(globalMap);
      //   globalMap.flyTo({center: lnglat})
      //   this.list = [];
      // },
      // switchDotStatus(){
      //   if(this.radio == '2'){
      //     this.list = [];
      //     markerPoi.remove();
      //     return;
      //   }
      //   if(this.inputContent == ""){
      //     this.list = [];
      //     markerPoi.remove();
      //     return;
      //   }
      //   let center = globalMap.getCenter();
      //   center = `${center.lng},${center.lat}`;
      //   utils.reverseGeoNglp(center).then(d=>{
      //       d = d.data;
      //       if(!d.data || !d.data.length){return this.toastMsgFunc('获取POI坐标信息出错！')}
      //       let adCode = d.data[0]['ad']['city'] || '110000';
      //       return utils.getPoiSuggestList(this.inputContent,{city:adCode});
      //   }).then((data => {
      //       let info = data[0].data;
      //       if (info.status != 200) {
      //           this.toastMsgFunc('请输入正确的关键字');
      //           return;
      //       }
      //       info = info.data;
      //       if (info.pois && info.pois.length > 0) {
      //           this.list = info.pois;
      //       }
      //   })).catch(err=>{
      //       if(err.message == '中断请求'){return}
      //   });
      // },
      search(){
        if(markerPoi != null){
          markerPoi.remove();
        }
        this.list = [];
        this.toastContent = false;
        if(this.radio == '2'){
          if(/^([+-]?\d{1,3}(\.\d+)?,[+-]?\d{1,2}(\.\d+)?;?)+$/.test(this.inputContent)){
            this.inputResult = this.inputContent;
            let lnglat = this.inputResult.split(',').map(v=>{return parseFloat(v)});
            markerPoi.setLngLat(lnglat);
            markerPoi.addTo(globalMap);
            globalMap.flyTo({center: lnglat})
          }else{
            this.toastMsgFunc('请输入正确的经纬度');
          }
        }else{
          if(this.inputContent == ""){
              return this.toastMsgFunc('请输入关键字');
          }
          let center = globalMap.getCenter();
          center = `${center.lng},${center.lat}`;
          utils.reverseGeoNglp(center).then(d=>{
              d = d.data;
              if(!d.data || !d.data.length){return this.toastMsgFunc('获取POI坐标信息出错！')}
              let adCode = d.data[0]['ad']['city'] || '110000';
              return utils.getPoiList(this.inputContent,{city:adCode});
          }).then((data => {
              let info = data[0].data;
              if (info.status != 200) {
                  markerPoi.remove();
                  this.inputResult = ''
                  this.toastMsgFunc('请输入正确的关键字');
                  return;
              }
              info = info.data;
              if (info.pois && info.pois.length > 0) {
                  let poi = info.pois[0];
                  let lnglat = poi.lonlat.split(',').map(v=>{return parseFloat(v)});
                  this.inputResult = poi.lonlat
                  markerPoi.setLngLat(lnglat);
                  markerPoi.addTo(globalMap);
                  globalMap.flyTo({center: lnglat})
              }else{
                  this.toastMsgFunc('无结果');
                  markerPoi.remove();
                  this.inputResult = ''
              }
          })).catch(err=>{
              if(err.message == '中断请求'){return}
          });
        }
      }
  }
}

</script>
<style>
.app{width:100%;height:100%}
.mapWrap{width:100%;border-top:4px solid #5553df;border-bottom:4px solid #5553df;position: absolute;top:190px;bottom:30px;left: 0px;right:0px}
.bar{height:100px;width: 900px;margin:0 auto;display: flex;}
.bar  .inputWrap{width:450px;}
.markerLnglat{
    background: #ffffff;
    height: 20px !important;
    min-width: 180px;
    padding: 5px;
    margin-left: 20px;
    font-size: 16px;
    border:1px solid #333;
    letter-spacing: 0.5px;
    color:#333;
}
#option-panel{ position: absolute; right: 40px; top: 210px; }
#option-panel{ height: 24px; padding: 4px; box-sizing: content-box;  background-color: #fff; }
#option-panel .city-selector, #option-panel .traffic,#option-panel .tool-box{ display: inline-block; }
#option-panel .city-name{ display: inline-block; height: 24px; padding: 0 10px 0 10px; line-height: 24px; color: #333; }
#option-panel .city-panel-box,
#option-panel .traffic-panel,
#option-panel .tool-panel{ position: absolute; right: 0; top: 36px; }
/**勿删，集成在lbs平台中 */
.top-nav, .top-nav:hover {
    background-color: #2e3037;
}
</style>
